// extracted by mini-css-extract-plugin
module.exports = {"root":"medical-waste-disposal-page_root__wMZvk"};